import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  ZoomControl,
} from "react-leaflet";
import * as L from "leaflet";

import { useAppDispatch, useAppSelector } from "../../hooks";
import { setActiveLocation } from "../../redux/features/locationsSlice";

import { Location } from "../../types";

import "./LocationsMapView.scss";
import "leaflet/dist/leaflet.css";

export interface LocationsMapViewProps {
  locations: Location[];
}

function LocationsMapView({ locations }: LocationsMapViewProps) {
  const dispatch = useAppDispatch();
  const activeLocationNumber = useAppSelector(
    (state) => state.locations.active,
  );

  const redIcon = new L.Icon({
    iconUrl: "/map/map-red-icon.png",
    shadowUrl: "/map/map-icon-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  const grayIcon = new L.Icon({
    iconUrl: "/map/map-grey-icon.png",
    shadowUrl: "/map/map-icon-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  function LocationMarker({ location }: { location: Location }) {
    const {
      core: {
        locationName,
        physicalAddress: {
          coordinates: { latitude, longitude },
        },
      },
      locationNumber,
    } = location;

    return (
      <Marker
        position={[latitude, longitude]}
        icon={activeLocationNumber === locationNumber ? redIcon : grayIcon}
        eventHandlers={{
          click: () => dispatch(setActiveLocation(locationNumber)),
        }}
      >
        <Popup>
          {locationNumber} - {locationName}
        </Popup>
      </Marker>
    );
  }

  return (
    <div id="map">
      <MapContainer
        center={[39.8283, -98.5795]}
        zoom={5}
        zoomControl={false}
        zoomSnap={0}
        wheelPxPerZoomLevel={1}
        style={{ height: "100%", width: "100%" }}
      >
        <ZoomControl position="topright" />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {locations.map((l) => (
          <LocationMarker location={l} key={l.locationNumber} />
        ))}
      </MapContainer>
    </div>
  );
}

export default LocationsMapView;
